<template>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-52ef0f3 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="52ef0f3" data-element_type="section" data-e-type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
    <div class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-baf8def" data-id="baf8def" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-707d9fe elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-view-default elementor-invisible elementor-widget elementor-widget-icon-box" data-id="707d9fe" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
            <div class="elementor-widget-container">
              <div class="elementor-icon-box-wrapper">
                <div class="elementor-icon-box-icon">
                  <span  class="elementor-icon">
                    <i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
                  </span>
                </div>
                <div class="elementor-icon-box-content">
                  <h5 class="elementor-icon-box-title">
                    <span>News</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-71c9809 elementor-invisible elementor-widget elementor-widget-heading" data-id="71c9809" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;,&quot;_animation_delay&quot;:500}" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h2 class="elementor-heading-title elementor-size-default">Insights</h2>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-481f378 elementor-widget elementor-widget-text-editor" data-id="481f378" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              Our people are dedicated to finding solutions to every challenge. That spirit makes for some great stories.
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-b25cd99" data-id="b25cd99" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-c7c2839 elementor-grid-2 vamtam-has-hr-layout elementor-posts--align-left vamtam-nav-pos-custom elementor-grid-tablet-2 elementor-grid-mobile-1 elementor-posts--thumbnail-top vamtam-has-nav vamtam-has-title-underline-anim vamtam-has-read-more-theme-style elementor-widget elementor-widget-posts" data-id="c7c2839" data-element_type="widget" data-e-type="widget" data-settings="{&quot;vamtam_classic_columns&quot;:&quot;2&quot;,&quot;vamtam_classic_row_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0,&quot;sizes&quot;:[]},&quot;vamtam_classic_columns_tablet&quot;:&quot;2&quot;,&quot;vamtam_classic_columns_mobile&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="posts.vamtam_classic">
            <div class="elementor-widget-container">
              <div class="elementor-posts-container elementor-posts elementor-posts--skin-vamtam_classic elementor-grid" role="list">
                <article v-for="news in homeContentStore.contents.newsList" :key="news.id" class="elementor-post elementor-grid-item post-8101 post type-post status-publish format-standard has-post-thumbnail hentry category-innovation category-interior tag-awards tag-innovations tag-sustainability" role="listitem">
                  <a class="elementor-post__thumbnail__link" :href="`/news/details/` + news.slug" tabindex="-1" >
                    <div class="elementor-post__thumbnail">
                      <img decoding="async" width="1007" height="1210" :src="news.image" class="attachment-full size-full wp-image-8102" alt="" :data-lazy-srcset="news.image + ` 1007w, ` + news.image + ` 250w, ` + news.image + ` 852w, ` + news.image + ` 768w`" data-lazy-sizes="(max-width: 1007px) 100vw, 1007px" :data-lazy-src="news.image" />
                      <noscript><img loading="lazy" decoding="async" width="1007" height="1210" :src="news.image" class="attachment-full size-full wp-image-8102" alt="" :srcset="news.image + ` 1007w, ` + news.image + ` 250w, ` + news.image + ` 852w, ` + news.image + ` 768w`" sizes="(max-width: 1007px) 100vw, 1007px" /></noscript>
                    </div>
                  </a>
                  <!-- <div class="elementor-post__meta-data">
                    <div class="vamtam-post__categories">
                      <a href="https://konstruktion.vamtam.com/category/blog/innovation/" rel="category tag">Innovation</a>, 
                      <a href="https://konstruktion.vamtam.com/category/blog/interior/" rel="category tag">Interior</a>
                    </div>
                  </div> -->
                  <div class="elementor-post__text">
                    <h4 class="elementor-post__title">
                      <a :href="`/news/details/` + news.slug" >
                        {{news.title}}
                      </a>
                    </h4>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import '@splidejs/vue-splide/css';
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  const baseUploadURL = process.env.VUE_APP_API_URL;

  export default {
    name: 'NewsSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
      })

      return {
        homeContentStore
      }
    },
    data() {
      return{
        baseUploadURL: baseUploadURL,
      }
    },
  }
</script>

<style scoped>
  .elementor-kit-5 h2 {
    font-size: 40px;
  }
</style>